import { useOrganizationSettings } from "./useOrganizationSettings";
import { useOrgFeatureFlag } from "./useOrgFeatureFlag";

type FeatureFlagKey = keyof NonNullable<
  NonNullable<
    ReturnType<typeof useOrganizationSettings>["data"]
  >["feature_flags"]
>;

export const useWorkplaceRequestsAllowed = (key: FeatureFlagKey) => {
  const workplaceRequestsFeatureFlag = useOrgFeatureFlag("workplace_requests");
  return !!workplaceRequestsFeatureFlag;
};
